import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { connect } from "react-redux";
import Hero from "../../components/hero/hero";
import About from "../../components/about/about";
import PillarsSection from "../../components/PillarsSection/PillarsSection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import FunFact from "../../components/FunFact/FunFact";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ShopProduct from "../../components/ShopProduct";
import { useProducts } from "../../api";
import { useTranslation } from "react-i18next";
import { addToCart } from "../../store/actions/action";

const HomePage = (props) => {
    const { data: products = [], isLoading, error } = useProducts();
    const { addToCart } = props
      const { t } = useTranslation();
    
  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty, null, null, t);
  };

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-4"} />
      <Hero />
      {/* <About /> */}
      {/* <PillarsSection /> */}
      {/* <ServiceSection /> */}
      <div className="next-section">
        <a href="#shop" className="go-to">
          <i className="fi flaticon-down-arrow-sign"></i>
        </a>
        </div>
            <ShopProduct
              addToCartProduct={addToCartProduct}
              products={products}
              isLoading={isLoading}
              error={error}
            />
      {/* <FunFact /> */}
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default connect(null, { addToCart })(HomePage);